export default __webpack_public_path__ + "static/media/frame-1-bg.52496106.png";